import { useContext } from "react";
import TranslationContext from "../translation/TranslationContext";
export const useTranslation = () => useContext(TranslationContext);
